module.exports = __webpack_public_path__ + "img/tw-btn_txt.4291798b.png";